/**
 * Task C: online shop — 网上订单 inbox, Settings → 网上商城, daily close by channel.
 * One row per key: [key, English, 中文, Bahasa Melayu]; registered in ../modules.ts for the completeness test.
 */
const ROWS = [
  ["nav.onlineOrders","Online orders","网上订单","Pesanan dalam talian"],
  ["nav.shop","Online shop","网上商城","Kedai dalam talian"],
  ["shop.inbox.sub","Orders from your website. New paid orders also ping this device.","来自官网的订单。新的已付款订单会在本设备提醒。","Pesanan dari laman web anda. Pesanan baharu yang dibayar juga dimaklumkan pada peranti ini."],
  ["shop.inbox.search","Search order, name, phone, tracking","搜索订单号、姓名、电话、运单号","Cari pesanan, nama, telefon, penjejakan"],
  ["shop.inbox.empty","No online orders here","暂无网上订单","Tiada pesanan dalam talian"],
  ["shop.inbox.emptyBody","New orders from your website appear here.","官网的新订单会显示在这里。","Pesanan baharu dari laman web anda dipaparkan di sini."],
  ["shop.inbox.unseen","Not opened yet","未查看","Belum dibuka"],
  ["shop.filter.new","New","新订单","Baharu"],
  ["shop.filter.open","In progress","处理中","Dalam proses"],
  ["shop.filter.closed","Closed","已结束","Ditutup"],
  ["shop.filter.all","All","全部","Semua"],
  ["shop.status.awaiting_payment","Awaiting payment","待付款","Menunggu bayaran"],
  ["shop.status.new","New","新订单","Baharu"],
  ["shop.status.confirmed","Confirmed","已确认","Disahkan"],
  ["shop.status.preparing","Preparing","备货中","Sedang disediakan"],
  ["shop.status.shipped","Shipped","已发货","Dihantar"],
  ["shop.status.ready_for_pickup","Ready for pickup","可自取","Sedia diambil"],
  ["shop.status.completed","Completed","已完成","Selesai"],
  ["shop.status.cancelled","Cancelled","已取消","Dibatalkan"],
  ["shop.status.refunded","Refunded","已退款","Dibayar balik"],
  ["shop.status.expired","Not paid in time","超时未付款","Tidak dibayar dalam masa"],
  ["shop.fulfil.delivery","Delivery","配送","Penghantaran"],
  ["shop.fulfil.pickup","Pickup","自取","Ambil sendiri"],
  ["shop.pay.stripe","Card (online)","在线刷卡","Kad (dalam talian)"],
  ["shop.pay.cod","Cash on delivery","货到付款","Tunai semasa penghantaran"],
  ["shop.pay.pay_on_pickup","Pay at pickup","自取时付款","Bayar semasa ambil"],
  ["shop.pay.credit","Store credit","储值余额","Kredit kedai"],
  ["shop.paid","Paid","已付款","Dibayar"],
  ["shop.stockIssue","Stock check","库存待核","Semak stok"],
  ["shop.stockIssueHelp","This order was paid after its stock hold ran out and the item may no longer be on the shelf. Check the stock, or refund the customer.","该订单在库存保留到期后才付款，商品可能已无库存。请核对库存或为顾客退款。","Pesanan ini dibayar selepas tempoh simpanan stok tamat dan item mungkin sudah tiada. Semak stok atau bayar balik pelanggan."],
  ["shop.receipt","Receipt {label}","收据 {label}","Resit {label}"],
  ["shop.cancelReason","Reason for cancelling","取消原因","Sebab pembatalan"],
  ["shop.confirmCancel","Cancel this order","取消此订单","Batalkan pesanan ini"],
  ["shop.customerProfile","Customer profile","顾客档案","Profil pelanggan"],
  ["shop.deliverTo","Deliver to","送至","Hantar ke"],
  ["shop.pickupAt","Pickup at","自取地点","Ambil di"],
  ["shop.stock.held","on hold","暂留","ditahan"],
  ["shop.stock.reserved","reserved","已预留","dikhaskan"],
  ["shop.stock.consumed","taken from stock","已出库","dikeluarkan dari stok"],
  ["shop.stock.released","returned to stock","已释放","dipulangkan ke stok"],
  ["shop.tax","Tax","税","Cukai"],
  ["shop.total","Total","合计","Jumlah"],
  ["shop.refunded","Refunded","已退款","Dibayar balik"],
  ["shop.tracking","Delivery tracking","物流信息","Penjejakan penghantaran"],
  ["shop.courier","Courier","快递公司","Kurier"],
  ["shop.trackingNo","Tracking number","运单号","Nombor penjejakan"],
  ["shop.trackingUrl","Tracking link","物流链接","Pautan penjejakan"],
  ["shop.saveTracking","Save and tell the customer","保存并通知顾客","Simpan dan maklumkan pelanggan"],
  ["shop.history","History","记录","Sejarah"],
  ["shop.byCustomer","customer","顾客","pelanggan"],
  ["shop.order","Online order #{label}","网上订单 #{label}","Pesanan dalam talian #{label}"],
  ["shop.action.confirmed","Confirm order","确认订单","Sahkan pesanan"],
  ["shop.action.preparing","Start preparing","开始备货","Mula sediakan"],
  ["shop.action.shipped","Mark as shipped","标记已发货","Tanda sudah dihantar"],
  ["shop.action.ready_for_pickup","Ready for pickup","标记可自取","Sedia untuk diambil"],
  ["shop.action.completed","Complete","完成订单","Selesai"],
  ["shop.action.cancelled","Cancel order","取消订单","Batalkan pesanan"],
  ["shop.takePayment","Take payment at the POS","到收银台收款","Terima bayaran di POS"],
  ["shop.refund","Refund","退款","Bayar balik"],
  ["shop.newOrderToast","New online order","有新的网上订单","Pesanan dalam talian baharu"],
  ["shop.channel.online","Online shop","网上商城","Kedai dalam talian"],
  ["shop.channel.pos","Counter (POS)","门店收银","Kaunter (POS)"],
  ["shop.close.byChannel","By sales channel","按销售渠道","Mengikut saluran jualan"],
  ["shop.s.addonTitle","Online shop is an add-on","网上商城为附加功能","Kedai dalam talian ialah tambahan"],
  ["shop.s.addonBody","Add the Online shop under Add-ons to sell your products on your website.","请在「附加功能」中开通网上商城，即可在官网销售产品。","Tambah Kedai dalam talian di bahagian Tambahan untuk menjual produk di laman web anda."],
  ["shop.s.sub","Sell your POS products on your website. Orders arrive in Online orders with stock, receipts and daily close like counter sales.","在官网销售 POS 产品。订单进入「网上订单」，库存、收据和日结与门店销售一致。","Jual produk POS anda di laman web. Pesanan masuk ke Pesanan dalam talian dengan stok, resit dan tutup harian seperti jualan kaunter."],
  ["shop.s.sitePublish","Publish your website so customers can reach the shop.","请先发布官网，顾客才能访问商城。","Terbitkan laman web anda supaya pelanggan boleh ke kedai."],
  ["shop.s.noCard","Card payments need your own Stripe account (Settings → Payments). Until then customers can only use cash on delivery / pay at pickup if you enable them.","在线刷卡需先连接您自己的 Stripe 账户（设置 → 收款）。在此之前，仅可使用您开启的货到付款 / 自取付款。","Bayaran kad memerlukan akaun Stripe anda sendiri (Tetapan → Bayaran). Sehingga itu pelanggan hanya boleh guna tunai semasa penghantaran / bayar semasa ambil jika diaktifkan."],
  ["shop.s.general","Shop","商城","Kedai"],
  ["shop.s.enabled","Shop open","开放商城","Kedai dibuka"],
  ["shop.s.branch","Fulfilment branch","发货门店","Cawangan penghantaran"],
  ["shop.s.branchHint","Stock, prices and tax come from this branch.","库存、价格和税率以此门店为准。","Stok, harga dan cukai diambil dari cawangan ini."],
  ["shop.s.minOrder","Minimum order","最低订单金额","Pesanan minimum"],
  ["shop.s.hold","Unpaid card orders hold stock for (minutes)","未付款订单保留库存（分钟）","Pesanan kad belum bayar menahan stok selama (minit)"],
  ["shop.s.lowStock","Show “only a few left” at","库存少于等于此数量时显示“库存紧张”","Papar “tinggal sedikit” pada"],
  ["shop.s.backorder","Allow orders when sold out (backorder)","售罄时仍可下单（预订）","Benarkan pesanan apabila habis (tempahan)"],
  ["shop.s.delivery","Delivery","配送","Penghantaran"],
  ["shop.s.deliveryOn","Offer delivery","提供配送","Tawarkan penghantaran"],
  ["shop.s.mode","Delivery fee","运费方式","Caj penghantaran"],
  ["shop.s.mode.flat","Flat fee per order","每单固定运费","Caj tetap setiap pesanan"],
  ["shop.s.mode.per_item","Fee per item","按件计费","Caj setiap item"],
  ["shop.s.mode.postcode_zones","Zones by postcode","按邮编分区","Zon mengikut poskod"],
  ["shop.s.mode.distance_bands","Distance bands","按距离分段","Jalur jarak"],
  ["shop.s.fee","Fee","运费","Caj"],
  ["shop.s.perItem","Fee per item","每件运费","Caj setiap item"],
  ["shop.s.freeOver","Free delivery from (optional)","满额免运费（可选）","Penghantaran percuma dari (pilihan)"],
  ["shop.s.zoneName","Zone name","区域名称","Nama zon"],
  ["shop.s.postcodes","Postcodes","邮编","Poskod"],
  ["shop.s.addZone","Add zone","添加区域","Tambah zon"],
  ["shop.s.zoneHint","Postcodes: exact (10450), prefix (10*) or range (11000-11999). Addresses outside every zone can't order delivery.","邮编：精确（10450）、前缀（10*）或区间（11000-11999）。不在任何区域的地址无法选择配送。","Poskod: tepat (10450), awalan (10*) atau julat (11000-11999). Alamat di luar semua zon tidak boleh memilih penghantaran."],
  ["shop.s.lat","Shop latitude","门店纬度","Latitud kedai"],
  ["shop.s.lng","Shop longitude","门店经度","Longitud kedai"],
  ["shop.s.upToKm","Up to km","最远公里数","Sehingga km"],
  ["shop.s.addBand","Add distance band","添加距离段","Tambah jalur jarak"],
  ["shop.s.pickupPay","Pickup & payment","自取与付款","Ambil sendiri & bayaran"],
  ["shop.s.pickupOn","Offer pickup at the salon","提供到店自取","Tawarkan ambil di salun"],
  ["shop.s.pickupHint","None ticked = all active branches.","不勾选＝所有营业中的门店。","Tiada ditanda = semua cawangan aktif."],
  ["shop.s.cod","Cash on delivery","货到付款","Tunai semasa penghantaran"],
  ["shop.s.payOnPickup","Pay at pickup","自取时付款","Bayar semasa ambil"],
  ["shop.s.storeCredit","Signed-in customers can pay with store credit","已登录顾客可用储值付款","Pelanggan log masuk boleh bayar dengan kredit kedai"],
  ["shop.s.people","Sales credit & notifications","业绩归属与通知","Kredit jualan & pemberitahuan"],
  ["shop.s.attribution","Sale credited to","业绩归属","Jualan dikreditkan kepada"],
  ["shop.s.attrNone","Nobody (no commission)","无（不计提成）","Tiada (tiada komisen)"],
  ["shop.s.emails","E-mail new orders to","新订单邮件通知","E-mel pesanan baharu kepada"],
  ["shop.s.push","Push new orders to the POS devices","推送新订单到收银设备","Hantar pesanan baharu ke peranti POS"],
  ["shop.s.texts","Terms & return policy","条款与退货政策","Terma & polisi pemulangan"],
  ["shop.s.terms","Terms","条款","Terma"],
  ["shop.s.returnPolicy","Return policy","退货政策","Polisi pemulangan"],
  ["shop.s.products","Products sold online","在官网销售的产品","Produk dijual dalam talian"],
  ["shop.s.productsHint","Tick 在官网销售 to sell a product. Stock shown for {branch} (available = on hand minus open orders).","勾选「在官网销售」即可上架。库存显示 {branch}（可售 = 现有库存 − 未完成订单）。","Tanda “Jual dalam talian” untuk menjual produk. Stok untuk {branch} (tersedia = stok semasa tolak pesanan terbuka)."],
  ["shop.s.categories","Shop categories","商城分类","Kategori kedai"],
  ["shop.s.newCategory","New category","新分类","Kategori baharu"],
  ["shop.s.noProducts","No retail products yet","暂无零售产品","Belum ada produk runcit"],
  ["shop.s.inactive","inactive","已停用","tidak aktif"],
  ["shop.s.posPrice","POS {price}","POS 价 {price}","POS {price}"],
  ["shop.s.variants","{n} options","{n} 个规格","{n} pilihan"],
  ["shop.s.stockOf","{available} available ({onHand} on hand)","可售 {available}（现有 {onHand}）","{available} tersedia ({onHand} dalam stok)"],
  ["shop.s.untracked","stock not tracked","不追踪库存","stok tidak dijejak"],
  ["shop.s.sellOnline","在官网销售 · Sell online","在官网销售","Jual dalam talian"],
  ["shop.s.salonUse","This product is for salon use only. Make it a retail product in Services & products first.","该产品仅供店内使用。请先在「服务与产品」中设为零售产品。","Produk ini untuk kegunaan salun sahaja. Jadikan produk runcit di Perkhidmatan & produk dahulu."],
  ["shop.s.onlinePrice","Online price (empty = POS price {price})","网店价（留空 = POS 价 {price}）","Harga dalam talian (kosong = harga POS {price})"],
  ["shop.s.category","Category","分类","Kategori"],
  ["shop.s.sort","Sort order","排序","Susunan"],
  ["shop.s.featured","Featured","推荐","Pilihan"],
  ["shop.s.name","Name on the website","官网显示名称","Nama di laman web"],
  ["shop.s.description","Description","描述","Penerangan"],
  ["shop.s.options","Options sold online","在线销售的规格","Pilihan dijual dalam talian"],
  ["shop.s.photos","Photos (from your website images)","图片（来自官网图片库）","Foto (dari imej laman web anda)"],
  ["shop.s.noPhotos","Upload photos in Website → Images first.","请先在「官网 → 图片」上传图片。","Muat naik foto di Laman web → Imej dahulu."],
  ["w7.ev.shop_order_received","Online order received","网上订单已收到","Pesanan dalam talian diterima"],
  ["w7.ev.shop_order_confirmed","Online order confirmed","网上订单已确认","Pesanan dalam talian disahkan"],
  ["w7.ev.shop_order_preparing","Online order being prepared","网上订单备货中","Pesanan dalam talian sedang disediakan"],
  ["w7.ev.shop_order_shipped","Online order shipped","网上订单已发货","Pesanan dalam talian dihantar"],
  ["w7.ev.shop_order_ready","Online order ready for pickup","网上订单可自取","Pesanan dalam talian sedia diambil"],
  ["w7.ev.shop_order_completed","Online order completed","网上订单已完成","Pesanan dalam talian selesai"],
  ["w7.ev.shop_order_cancelled","Online order cancelled","网上订单已取消","Pesanan dalam talian dibatalkan"],
  ["w7.ev.shop_order_refunded","Online order refunded","网上订单已退款","Pesanan dalam talian dibayar balik"],
  ["w6.todo.shop_stock_issue","Online order paid after its stock hold ran out","网上订单在库存保留到期后付款","Pesanan dalam talian dibayar selepas simpanan stok tamat"],
  ["apiError.online_order_locked","This is an online order. Change it under Online orders (cancel / refund).","这是网上订单，请在「网上订单」中处理（取消/退款）。","Ini pesanan dalam talian. Ubah di Pesanan dalam talian (batal / bayar balik)."],
  ["apiError.bad_transition","That step isn't possible for this order right now.","该订单当前无法进行此操作。","Langkah itu tidak boleh dibuat untuk pesanan ini sekarang."],
  ["apiError.payment_required","Take the payment first, then complete the order.","请先收款，再完成订单。","Terima bayaran dahulu, kemudian selesaikan pesanan."],
  ["apiError.refund_first","This order is paid. Refund it instead of cancelling.","该订单已付款，请改为退款。","Pesanan ini telah dibayar. Bayar balik dan bukannya batal."],
  ["apiError.reason_required","Give a reason.","请填写原因。","Berikan sebab."],
  ["apiError.shop_closed","The online shop is closed.","网上商城未开放。","Kedai dalam talian ditutup."],
  ["shop.status.partially_refunded","Partly refunded","部分退款","Dibayar balik sebahagian"],
  ["shop.h.placed","Placed {when}","下单时间 {when}","Dibuat {when}"],
  ["shop.h.steps","Order progress","订单进度","Kemajuan pesanan"],
  ["shop.h.stepFulfil","Shipped / ready","已发货 / 可自取","Dihantar / sedia"],
  ["shop.h.endedCancelled","Cancelled {when}","已于 {when} 取消","Dibatalkan {when}"],
  ["shop.h.endedRefunded","Refunded in full {when}","已于 {when} 全额退款","Dibayar balik penuh {when}"],
  ["shop.h.endedExpired","Not paid in time — stock released {when}","超时未付款，库存已于 {when} 释放","Tidak dibayar dalam masa — stok dilepaskan {when}"],
  ["shop.h.partlyRefundedNote","Part of this order was refunded; the rest can still be fulfilled.","此订单已部分退款，其余商品仍可继续处理。","Sebahagian pesanan ini telah dibayar balik; selebihnya masih boleh diproses."],
  ["shop.h.pay.unpaid","Unpaid","未付款","Belum dibayar"],
  ["shop.h.pay.partly","Partly refunded","部分退款","Dibayar balik sebahagian"],
  ["shop.h.pay.refunded","Refunded","已退款","Dibayar balik"],
  ["shop.h.more","More actions","更多操作","Tindakan lain"],
  ["shop.h.printReceipt","Print receipt","打印收据","Cetak resit"],
  ["shop.h.printSlip","Print packing slip","打印拣货单 / 装箱单","Cetak slip pembungkusan"],
  ["shop.h.resend","Resend notification","重新发送通知","Hantar semula pemberitahuan"],
  ["shop.h.resent","Notification queued for the customer","已重新发送通知给顾客","Pemberitahuan dihantar semula kepada pelanggan"],
  ["shop.h.addNote","Add note","添加备注","Tambah nota"],
  ["shop.h.editTracking","Edit tracking","修改物流信息","Ubah penjejakan"],
  ["shop.h.shipTitle","Shipping details","发货信息","Butiran penghantaran"],
  ["shop.h.shipHint","The customer gets the courier and tracking number in the shipped message.","发货通知中会附上快递公司和运单号。","Pelanggan menerima kurier dan nombor penjejakan dalam mesej penghantaran."],
  ["shop.h.trackingOptional","Tracking link (optional)","物流链接（可选）","Pautan penjejakan (pilihan)"],
  ["shop.h.cancelTitle","Cancel this order","取消此订单","Batalkan pesanan ini"],
  ["shop.h.keep","Keep order","保留订单","Kekalkan pesanan"],
  ["shop.h.sec.customer","Customer","顾客","Pelanggan"],
  ["shop.h.sec.fulfilment","Delivery / pickup","配送 / 自取","Penghantaran / ambil sendiri"],
  ["shop.h.sec.payment","Payment","付款","Bayaran"],
  ["shop.h.sec.items","Items","商品","Item"],
  ["shop.h.sec.customerNote","Customer note","顾客备注","Nota pelanggan"],
  ["shop.h.sec.staffNotes","Internal notes","内部备注","Nota dalaman"],
  ["shop.h.sec.timeline","Timeline","订单记录","Garis masa"],
  ["shop.h.call","Call","拨打","Panggil"],
  ["shop.h.whatsapp","WhatsApp","WhatsApp","WhatsApp"],
  ["shop.h.email","E-mail","邮件","E-mel"],
  ["shop.h.member","Member {no}","会员 {no}","Ahli {no}"],
  ["shop.h.tier","Tier {tier}","等级 {tier}","Tahap {tier}"],
  ["shop.h.points","{n} points","{n} 积分","{n} mata"],
  ["shop.h.notMember","Not a member yet","尚未成为会员","Belum menjadi ahli"],
  ["shop.h.fulfilBranch","Fulfilment branch","发货门店","Cawangan penghantaran"],
  ["shop.h.pickupBranch","Pickup branch","自取门店","Cawangan ambil sendiri"],
  ["shop.h.collectAt","Customer collects at {branch}","顾客到 {branch} 自取","Pelanggan ambil di {branch}"],
  ["shop.h.transfer","Transfer needed from {from} to {to}","需从 {from} 调货到 {to}","Pindahan stok diperlukan dari {from} ke {to}"],
  ["shop.h.transferChip","Transfer","调货","Pindahan"],
  ["shop.h.stock.reserved","reserved","已预留","dikhaskan"],
  ["shop.h.stock.consumed","taken from stock","已扣","ditolak dari stok"],
  ["shop.h.stock.released","returned to stock","已释放","dipulangkan ke stok"],
  ["shop.h.stock.short","out of stock","缺货","kehabisan stok"],
  ["shop.h.method","Method","付款方式","Kaedah"],
  ["shop.h.amount","Amount","金额","Jumlah"],
  ["shop.h.payStatusLabel","Status","状态","Status"],
  ["shop.h.reference","Reference","参考号","Rujukan"],
  ["shop.h.paidAt","Paid at","付款时间","Dibayar pada"],
  ["shop.h.refunds","Refunds","退款记录","Bayaran balik"],
  ["shop.h.creditUsed","Store credit used","已用储值","Kredit kedai digunakan"],
  ["shop.h.noPayment","No payment yet","尚未付款","Belum ada bayaran"],
  ["shop.h.toCollect","To collect: {amount}","待收款：{amount}","Perlu dikutip: {amount}"],
  ["shop.h.payMethod.cash","Cash","现金","Tunai"],
  ["shop.h.payMethod.external_card","Card (terminal)","刷卡（终端）","Kad (terminal)"],
  ["shop.h.payMethod.bank_transfer","Bank transfer","银行转账","Pindahan bank"],
  ["shop.h.payMethod.stripe","Card / online (Stripe)","在线付款（Stripe）","Kad / dalam talian (Stripe)"],
  ["shop.h.payMethod.credit","Store credit","储值","Kredit kedai"],
  ["shop.h.payMethod.none","No money back","不退款项","Tiada wang dipulangkan"],
  ["shop.h.payStatus.pending","Pending","待付款","Belum selesai"],
  ["shop.h.payStatus.requires_action","Waiting for the customer","等待顾客操作","Menunggu pelanggan"],
  ["shop.h.payStatus.processing","Processing","处理中","Sedang diproses"],
  ["shop.h.payStatus.succeeded","Paid","已付款","Dibayar"],
  ["shop.h.payStatus.failed","Failed","失败","Gagal"],
  ["shop.h.payStatus.canceled","Cancelled","已取消","Dibatalkan"],
  ["shop.h.col.item","Item","商品","Item"],
  ["shop.h.col.option","Option","规格","Pilihan"],
  ["shop.h.col.qty","Qty","数量","Kuantiti"],
  ["shop.h.col.unit","Unit price","单价","Harga seunit"],
  ["shop.h.col.total","Line total","小计","Jumlah baris"],
  ["shop.h.subtotal","Subtotal","商品小计","Jumlah kecil"],
  ["shop.h.discount","Discount","折扣","Diskaun"],
  ["shop.h.voucher","Voucher {code}","优惠券 {code}","Baucar {code}"],
  ["shop.h.deliveryFee","Delivery fee","运费","Caj penghantaran"],
  ["shop.h.notePlaceholder","Only staff see internal notes","内部备注仅员工可见","Hanya kakitangan melihat nota dalaman"],
  ["shop.h.saveNote","Save note","保存备注","Simpan nota"],
  ["shop.h.noteSaved","Note added","已添加备注","Nota ditambah"],
  ["shop.h.noNotes","No internal notes yet","暂无内部备注","Belum ada nota dalaman"],
  ["shop.h.tl.created","Order placed","顾客下单","Pesanan dibuat"],
  ["shop.h.tl.tracking","Tracking updated: {text}","物流信息已更新：{text}","Penjejakan dikemas kini: {text}"],
  ["shop.h.tl.note","Note","备注","Nota"],
  ["shop.h.tl.resend","Notification resent","重新发送通知","Pemberitahuan dihantar semula"],
  ["shop.h.tl.payment","Payment {amount} · {method}","收款 {amount} · {method}","Bayaran {amount} · {method}"],
  ["shop.h.tl.refund","Refund {amount} · {method}","退款 {amount} · {method}","Bayaran balik {amount} · {method}"],
  ["shop.h.tl.message","Message to customer: {event}","发送给顾客：{event}","Mesej kepada pelanggan: {event}"],
  ["shop.h.msg.scheduled","scheduled","已排期","dijadualkan"],
  ["shop.h.msg.queued","queued","排队中","dalam baris gilir"],
  ["shop.h.msg.sending","sending","发送中","menghantar"],
  ["shop.h.msg.sent","sent","已发送","dihantar"],
  ["shop.h.msg.delivered","delivered","已送达","diterima"],
  ["shop.h.msg.read","read","已读","dibaca"],
  ["shop.h.msg.failed","failed","发送失败","gagal"],
  ["shop.h.msg.skipped","not sent","未发送","tidak dihantar"],
  ["shop.h.msg.canceled","cancelled","已取消","dibatalkan"],
  ["shop.h.byStaff","by {name}","由 {name}","oleh {name}"],
  ["shop.h.filter.status","Status","状态","Status"],
  ["shop.h.filter.anyStatus","Any status (tabs)","全部状态（按标签）","Semua status (tab)"],
  ["shop.h.filter.type","Delivery / pickup","配送 / 自取","Penghantaran / ambil"],
  ["shop.h.filter.anyType","Delivery and pickup","配送和自取","Penghantaran dan ambil"],
  ["shop.h.filter.from","From","开始日期","Dari"],
  ["shop.h.filter.to","To","结束日期","Hingga"],
  ["shop.h.filter.clear","Clear filters","清除筛选","Kosongkan penapis"],
  ["shop.h.selectOrder","Select order {label}","选择订单 {label}","Pilih pesanan {label}"],
  ["shop.h.selectAll","Select all","全选","Pilih semua"],
  ["shop.h.selected","{n} selected","已选 {n} 个","{n} dipilih"],
  ["shop.h.bulkSlips","Print packing slips","打印拣货单","Cetak slip pembungkusan"],
  ["shop.h.paper","Paper","纸张","Kertas"],
  ["shop.h.pickupAtBranch","Pickup: {branch}","自取：{branch}","Ambil: {branch}"],
  ["shop.h.printPreview","Print preview","打印预览","Pratonton cetakan"],
  ["shop.h.printNow","Print","打印","Cetak"],
  ["shop.h.moreItems","+{n} more","另 {n} 件","+{n} lagi"],
  ["shop.s.pickupBranches","Pickup locations","自取门店","Lokasi ambil sendiri"],
  ["apiError.nothing_to_send","There is no customer message for an order in this status.","当前状态没有可发送给顾客的通知。","Tiada mesej pelanggan untuk pesanan dalam status ini."],
  ["apiError.bad_ids","Pick 1–100 orders to print.","请选择 1–100 个订单打印。","Pilih 1–100 pesanan untuk dicetak."],
] as const;

export type ShopKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2 | 3) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<ShopKey, string>;

export const shop = { en: col(1), zh: col(2), ms: col(3) };
